var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 34 38",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.793 14.636H31.91a.798.798 0 01.74.844v18.235a3.188 3.188 0 01-2.957 3.367H8.01a3.188 3.188 0 01-2.957-3.367V15.478a.798.798 0 01.74-.842zM32.65 11.55V9.025a3.188 3.188 0 00-2.957-3.366l-4.007.584-.403-3.38c0-.463.407-1.14 0-1.14l-1.75-.554c-.407 0-1.927.375-1.927.844v2.87l-.21.775-8.726.584-.962-2.704c0-.463.407-1.525 0-1.525v-.844c-.41 0-2.218.375-2.218.844L8.01 4.169v1.489a3.188 3.188 0 00-2.957 3.367v2.525a.798.798 0 00.74.844H31.91a.798.798 0 00.74-.844z",
    fill: "url(#calendar_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.813 19.969a2.344 2.344 0 10-4.688 0 2.344 2.344 0 004.688 0zM12.813 27.469a2.344 2.344 0 10-4.688 0 2.344 2.344 0 004.688 0zM20.313 19.969a2.344 2.344 0 10-4.688 0 2.344 2.344 0 004.688 0zM20.313 27.469a2.344 2.344 0 10-4.688 0 2.344 2.344 0 004.688 0zM27.813 19.969a2.344 2.344 0 10-4.688 0 2.344 2.344 0 004.688 0zM27.813 27.469a2.344 2.344 0 10-4.688 0 2.344 2.344 0 004.688 0z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.188 2.75v2.563h1.624V2.75H9.188zm-1-2a1 1 0 00-1 1v3.732H4.624a4 4 0 00-4 4v23.83a4 4 0 004 4h24.857a4 4 0 004-4V9.483a4 4 0 00-4-4h-3.544V1.75a1 1 0 00-1-1h-3.625a1 1 0 00-1 1v3.732h-7.5V1.75a1 1 0 00-1-1H8.187zm21.294 6.732H4.625a2 2 0 00-2 2v23.83a2 2 0 002 2h24.857a2 2 0 002-2V9.483a2 2 0 00-2-2zm-7.17-2.17V2.75h1.625v2.563h-1.625z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.5h-2v-5h2v5zM11 7.5H9v-5h2v5z",
    fill: "#1770D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar_svg__paint0_linear",
    x1: 18.852,
    y1: 1.169,
    x2: 18.852,
    y2: 37.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439AFF"
  })))));
};
export default SvgCalendar;